import { C, IMG_COLORS, IMG_LABELS } from "../data/constants";
import { scrollTo } from "../hooks/useScrollFade";

export default function Hero() {
  return (
    <section id="home" style={{ minHeight: "100vh", paddingTop: 62, position: "relative", display: "flex", alignItems: "center", justifyContent: "center", background: C.dark, overflow: "hidden" }}>
      <style>{`
        .hero-bg {
          position: absolute; inset: 0;
          display: grid; grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr 1fr; gap: 2px; opacity: 0.3;
        }
        .hero-overlay {
          position: absolute; inset: 0;
          background: radial-gradient(ellipse at center, rgba(44,40,38,0.6) 0%, rgba(44,40,38,0.95) 100%);
        }
        .hero-content {
          position: relative; z-index: 2;
          width: 100%; max-width: 900px;
          margin: 0 auto;
          padding: clamp(60px,8vw,120px) clamp(24px,5vw,60px);
          text-align: center;
          display: flex; flex-direction: column; align-items: center;
        }
        .hero-eyebrow {
          color: #CDACA1;
          letter-spacing: clamp(3px, 0.5vw, 6px);
          text-transform: uppercase;
          font-size: clamp(10px, 1vw, 12px);
          margin-bottom: 28px;
        }
        .hero-rule {
          width: 48px; height: 1px;
          background: #CDACA1;
          margin: 0 auto 32px;
          opacity: 0.6;
        }
        .hero-h1 {
          font-size: clamp(56px, 9vw, 110px);
          color: #FAFAF8;
          font-weight: 300;
          line-height: 1.0;
          margin-bottom: 12px;
          letter-spacing: -1px;
        }
        .hero-h1 em {
          color: #DDC8B7;
          font-style: italic;
          font-weight: 300;
        }
        .hero-tag {
          color: #DFD8C5;
          font-size: clamp(16px, 2vw, 22px);
          line-height: 1.8;
          margin-bottom: 16px;
          font-family: 'Cormorant Garamond', serif;
          font-weight: 300;
          font-style: italic;
          letter-spacing: 1px;
        }
        .hero-sub {
          color: rgba(221,200,183,0.7);
          font-size: clamp(12px, 1.3vw, 14px);
          line-height: 2;
          margin-bottom: 48px;
          letter-spacing: 2px;
          text-transform: uppercase;
        }
        .hero-btns {
          display: flex; gap: 16px; flex-wrap: wrap;
          justify-content: center;
        }
        .hero-btn-primary {
          background: #CDACA1; color: #FAFAF8; border: none;
          padding: clamp(13px,1.5vw,16px) clamp(32px,4vw,52px);
          border-radius: 40px;
          font-size: clamp(13px, 1.3vw, 15px);
          cursor: pointer; font-family: 'Jost', sans-serif;
          letter-spacing: 1px;
          transition: all 0.3s ease;
        }
        .hero-btn-primary:hover { background: #B89A8F; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(205,172,161,0.35); }
        .hero-btn-secondary {
          background: transparent; color: #FAFAF8;
          border: 1px solid rgba(223,216,197,0.35);
          padding: clamp(13px,1.5vw,16px) clamp(32px,4vw,52px);
          border-radius: 40px;
          font-size: clamp(13px, 1.3vw, 15px);
          cursor: pointer; font-family: 'Jost', sans-serif;
          letter-spacing: 1px;
          transition: all 0.3s ease;
        }
        .hero-btn-secondary:hover { border-color: rgba(223,216,197,0.8); transform: translateY(-2px); }
        .hero-dots {
          position: absolute; bottom: 36px; left: 50%;
          transform: translateX(-50%);
          display: flex; gap: 12px; z-index: 3;
        }
        .hero-scroll-hint {
          position: absolute; bottom: 36px; left: 50%;
          transform: translateX(-50%);
          display: flex; flex-direction: column; align-items: center; gap: 8px;
          z-index: 3; cursor: pointer;
          animation: bounce 2s infinite;
        }
        @keyframes bounce {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50%       { transform: translateX(-50%) translateY(6px); }
        }
        @media (max-height: 600px) { .hero-scroll-hint { display: none !important; } }
        @media (max-width: 480px) {
          .hero-btns { flex-direction: column; width: 100%; max-width: 280px; }
          .hero-btn-primary, .hero-btn-secondary { width: 100%; }
        }
      `}</style>

      {/* Background image grid */}
      <div className="hero-bg">
        {[0,1,2,6,11,17].map(i => (
          <div key={i} style={{ background: IMG_COLORS[i], display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "rgba(255,255,255,0.3)", textAlign: "center", padding: 6 }}>
            <span>{IMG_LABELS[i]}</span>
          </div>
        ))}
      </div>

      {/* Radial gradient overlay — dark centre for text readability */}
      <div className="hero-overlay" />

      {/* Decorative top line */}
      <div style={{ position: "absolute", top: 80, left: "50%", transform: "translateX(-50%)", width: 1, height: "clamp(40px,5vw,60px)", background: "linear-gradient(to bottom, transparent, rgba(205,172,161,0.4))", zIndex: 2 }} />

      {/* Content — centred */}
      <div className="hero-content">
        <div className="fade" style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>

          <p className="hero-eyebrow">Cape Town's Boutique Event Designers</p>

          <div className="hero-rule" />

          <h1 className="hero-h1">
            Moments<br />&amp; <em>Milestones</em>
          </h1>

          <p className="hero-tag">Where every detail tells your story</p>

          <p className="hero-sub">
            Proposals &nbsp;·&nbsp; Birthdays &nbsp;·&nbsp; Valentine's &nbsp;·&nbsp; Anniversaries<br />
            Balloon Décor &nbsp;·&nbsp; Custom Cakes &nbsp;·&nbsp; Handcrafted Gifts
          </p>

          <div className="hero-btns">
            <button className="hero-btn-primary" onClick={() => scrollTo("packages")}>
              View Packages
            </button>
            <button className="hero-btn-secondary" onClick={() => scrollTo("build-your-own")}>
              Build Your Own
            </button>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="hero-scroll-hint" onClick={() => scrollTo("services")}>
        <span style={{ color: "rgba(205,172,161,0.6)", fontSize: 10, letterSpacing: 3, textTransform: "uppercase" }}>Scroll</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 3v10M4 9l4 4 4-4" stroke="rgba(205,172,161,0.6)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </section>
  );
}